import { useEffect } from 'react';
import styles from './TemplateList.module.scss'
import { TemplateItem } from '../TemplateItem/TemplateItem';
import { EViewType, useURLRouting } from '../../../utils/hooks/useURLRouting';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { fetchTemplateFoldersThunk } from '../../../redux/reducers/ui/uiThunks';
import { getTemplateFolders } from '../../../redux/reducers/ui/uiSelectors';
import { getFoldersCount } from '../../../redux/reducers/ui/selectors/templateSelectors';
import { useUrlPagination } from '../../../utils/hooks/useUrlPagination';
import { Pagination } from '../../../components/Pagination/Pagination';
import { HelperService } from '../../../services/HelperService';
import { FolderList } from './components/FolderList/FolderList';

export const TemplateList = () => {
  const dispatch = useAppDispatch();
  const { currentView, setTemplate } = useURLRouting();
  
  // Determine current view state
  // TemplateItem shows folder details with templates list when a folder is selected
  const isShowingFolderDetail = currentView?.type === EViewType.Templates && 
    currentView.template_id && Number(currentView.template_id) >= 0;
  // Show folders list when no specific folder is selected
  const isShowingFolders = !currentView || 
    currentView.type !== EViewType.Templates || 
    !currentView.template_id;

  // Folder pagination (only used when showing folders)
  const FOLDERS_PAGINATION_KEY = 'folders';
  const { page: foldersPage, setPage: setFoldersPage } = useUrlPagination(
    FOLDERS_PAGINATION_KEY, 
    1, 
    false
  );
  
  const templateFolders = useAppSelector(getTemplateFolders());
  const foldersCount = useAppSelector(getFoldersCount());

  const getTemplateFoldersList = async () => {
    if (isShowingFolders) {
      await dispatch(fetchTemplateFoldersThunk({ page: foldersPage })).unwrap();
    }
  };

  useEffect(() => {
    // Fetch template folders on component mount or when switching to folder view
    getTemplateFoldersList();
  }, [isShowingFolders]);

  useEffect(() => {
    // Fetch template folders when page changes (only for folders)
    if (isShowingFolders) {
      getTemplateFoldersList();
    }
  }, [foldersPage, isShowingFolders]);
    
  const handleSetActiveTemplate = (templateId?: number) => {
    setTemplate(String(templateId))
  }

  return (
    <div className={styles.content}>
      {isShowingFolderDetail ? (
        <TemplateItem templateName={Number(currentView.template_id)} />
      ) : (
        <>
          <FolderList 
            folders={templateFolders || []}
            onFolderClick={handleSetActiveTemplate}
          />
          <div className={styles.pagination}>
            <Pagination
              currentPage={foldersPage}
              totalPages={HelperService.getPagesCount(foldersCount)}
              onPageChange={setFoldersPage}
            />
          </div>
        </>
      )}
    </div>
  )
}
